<template>
    <div>
        <!-- import account -->
        <app-account></app-account>

        <!-- profile contents -->
        <template v-if="activeUser">
            <div class="container spread-outz">
                <div class="row mt-4 profile-bio-row">
                    <div class="col-md-9 col-12 profile-head-details">
                        <div class="row">
                            <div class="col-md-6 col-sm-6 col-12 d-flex">
                                <!-- display user full name -->
                                <h4>{{activeUser.name | capitalize}}</h4>

                                <!-- display edit profile btn -->
                                <router-link :to="{ name: 'settings', query: { bio: null } }" v-if="authenticated && activeUser._id == user._id">
                                    <span class="btn btn-light btn-sm p-0 px-1 ml-1"><i class="far fa-edit fa-xs"></i> edit</span>
                                </router-link>
                            </div>
                        </div>
                        <!-- show users bio - aka page info -->
                        <p v-if="activeUser.bio" class="bio-text mb-4">{{activeUser.bio}}</p>
                        <hr>
                        <dl class="row mt-5 profile-details">
                            <dt class="col-sm-4 col-6">aTrue Member</dt>
                            <dd class="col-sm-8 col-6">
                                <p v-if="aTrueMember" class="text-dark-green"><i class="fas fa-user-shield"></i> Yes!</p>
                                <p v-else class="text-danger">
                                    <i class="fas fa-user-shield"></i> No! 
                                    <small @click="showVerifyEmailFxn" v-if="authenticated && activeUser._id == user._id" class="btn btn-light btn-sm p-0 px-1 ml-1">
                                        <i class="far fa-edit fa-xs"></i> change
                                    </small>
                                </p>
                            </dd>
                            
                            <dt class="col-sm-4 col-6">Verified Contacts</dt>
                            <dd class="col-sm-8 col-6">
                                <p class="text-capitalize">
                                    <i class="fas fa-id-card"></i> {{verifiedContacts}}
                                </p>
                            </dd>
                            
                            <dt class="col-sm-4 col-6">Shop+</dt>
                            <dd class="col-sm-8 col-6">
                                <p v-if="sellsAs"><i class="fas fa-store"></i> {{activeUser.shopName}}</p>
                                <p v-else><i class="fas fa-store-slash"></i> None Yet</p>
                            </dd>
                        </dl>
                        <hr>
                        <dl class="row">
                            <dt class="col-sm-4 col-6">Member Since</dt>
                            <dd class="col-sm-8 col-6"><p>{{activeUser.joined | moment("MMMM YYYY")}}</p></dd>
                            
                            <dt class="col-sm-4 col-6">Approx. Location</dt>
                            <dd class="col-sm-8 col-6"><p class="text-capitalize">{{approxLocation}}</p></dd>

                            <dt class="col-sm-4 col-6">Items Purchased</dt>
                            <dd class="col-sm-8 col-6"><p>{{itemsPurchased}}</p></dd>
                        </dl>
                        <hr>
                        <div v-if="myRecentSellings" class="row mt-2 list-item-details">
                            <div class="col-12">
                                <h4>My Recent Items</h4>
                            </div>
                        </div>
                        <div v-if="myRecentSellings" class="row mb-5">
                            <app-user-item v-for="(item, i) in myRecentSellings" :key="i" :item="item"></app-user-item>
                        </div>
                    </div>
                    <div class="col-md-3 col-12 profile-review-box">
                        <h4 class="pt-2">Reviews</h4>
                        <hr>
                        <template v-if="myReviewsList">
                            <div class="reviews" v-for="(reviews, i) in myReviewsList" :key="i">
                                <strong class="text-dark text-capitalize">
                                    <i class="fas fa-user"></i> {{reviews.name}}
                                </strong> <br>
                                <small class="text-warning mr-3">
                                    <template><i v-for="x in reviews.stars" :key="x + 0.321" class="fas fa-star"></i></template>
                                    <template><i v-for="y in 5 - reviews.stars" :key="y + 0.456" class="far fa-star"></i></template>
                                </small><br>
                                <span class="text-muted reviews-text">{{reviews.note | capitalize}}</span><br>
                                <small class="text-muted reviews-text">
                                    <i class="fas fa-clock"></i> {{reviews.joined | moment("MMM D 'YY hh:mm A")}}
                                </small>
                                <hr>
                            </div>
                        </template>
                        <template v-else>
                            <p class="text-muted">No reviews yet!</p>
                        </template>
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <!-- lazy load while items get fetched -->
            <app-profile-holder></app-profile-holder>
        </template>

        <!-- type review note -->
        <app-ghost-mode v-if="showNote">
            <div class="row">
                <div class="col-12">
                    <div class="jumbotron screen-center p-4">
                        <h4 class="text-center"><i v-for="(x, i) in stars" :key="i + 0.369" class="fas fa-star text-warning"></i></h4>
                        <p class="text-center my-3 font-weight-bold">Write an optional review</p>
                        <div class="form-group">
                            <textarea v-model="note" class="form-control no-lines bg-white" rows="5"></textarea>
                        </div>
                        <button @click="submitReview" class="loadn btn btn-dark-green form-control btn-lg">Submit</button>
                    </div>
                </div>
            </div>
        </app-ghost-mode>

        <!-- show validate email window -->
        <app-validate-email v-if="showVerifyEmail"></app-validate-email>
        
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { eventBus } from '@/main'

import Account from '../shared/Account.vue'
import UserItem from '../shared/UserItem.vue'
import Placeholder from '../shared/Placeholder.vue'
import GhostMode from '@/components/general/shared/GhostMode.vue'
import LayoutUser from '@/layouts/User.vue'
import ProfileHolder from './profileParts/ProfileHolder.vue'
import ValidateEmail from './settingsParts/ValidateEmail.vue'

export default {
    name: "Profile",
    data() {
        return {
            note: '',
            stars: 0,
            showNote: false,
            showVerifyEmail: false,
            showJoinMarketer: false
        }
    },
    methods: {
        ...mapActions(['lookupAuthorization', 'footerFixed', 'itemsIamSelling', 'addReview']),
        showVerifyEmailFxn() {
            this.showVerifyEmail = true
        },
        showJoinMarketerFxn() {
            this.showJoinMarketer = true
        },
        updatePage(newUserHandle){
            let handleObj = {
                handle: newUserHandle
            }
            this.lookupAuthorization(handleObj).then(() => {}).catch((e) => {})
        },
        reviewUser(stars) {
            if(this.authenticated && this.lookupUser){
                this.stars = stars
                this.showNote = true
            }
        },
        submitReview() {
            let reviewObj = {
                reviewerId: this.user._id,
                revieweeId: this.lookupUser._id,
                stars: this.stars,
                note: this.note,
                itemId: this.reviewTrans.itemId,
                sellerId: this.reviewTrans.sellerId,
                buyerId: this.reviewTrans.buyerId
            }
            this.addReview(reviewObj)
            .then(() => {
                this.stars = 0
                this.note = ''
                this.showNote = false
            })
        }
    },
    computed: {
        ...mapGetters(['user', 'authenticated', 'lookupUser', 'sellings', 'sellerItems', 'navCounter', 'myReviews', 'reviewTrans']),
        aTrueMember() {
            if(this.activeUser.emailConfirmed){
                return true
            }
            return false
        },
        verifiedContacts() {
            let contactsArr = []
            if(this.activeUser.emailConfirmed){
                contactsArr.push('email')
            }
            if(this.activeUser.phoneConfirmed){
                // NOTE: make sure to sent OTP to phone numbers as confrimation b4 deploying !!!
                contactsArr.push('phone')
            }
            if(contactsArr.length === 0){
                contactsArr.push('none')
            }
            return contactsArr.join(", ")
        },
        sellsAs() {
            if(this.activeUser.shopOwner){
                return true
            }
            return false
        },
        activeUser() {
            if(this.lookupUser !== null){
                return this.lookupUser
            }
            else if(this.user !== null){
                return this.user
            }
            else {
                return false
            }
        },
        approxLocation() {
            if(this.activeUser.neighborhood){
                return `${this.activeUser.neighborhood}, ${this.activeUser.stateCode}`
            }
            else if(this.activeUser.city){
                return `${this.activeUser.city}, ${this.activeUser.stateCode}`
            }
            else if(this.activeUser.lga){
                return `${this.activeUser.lga}, ${this.activeUser.stateCode}`
            }
            else if(this.activeUser.state){
                return `${this.activeUser.state}, ${this.activeUser.alphaCode}`
            }
            else {
                return `${this.activeUser.country}`
            }
        },
        myRecentSellings() {
            // show latest 3 items of the lookedup user here
            if(this.sellerItems && this.sellerItems !== null){
                return this.sellerItems.itemsArr.slice(0, 3)
            }
            // show the latest 3 items of the logged in user - !this.lookupUser ensures that
            if(this.sellings && this.sellings !== null && !this.lookupUser){
                return this.sellings.slice(0, 3)
            }
            return false
        },
        itemsPurchased() {
            let purchasedCount = 0
            if(this.navCounter) { purchasedCount = this.navCounter.purchased }
            if(this.lookupUser) { purchasedCount = this.lookupUser.purchased }
            if(purchasedCount == 1){
                return `${purchasedCount} Item`
            }
            else if(purchasedCount > 1){
                return `${purchasedCount} Items`
            }
            return `None Yet`
        },
        myReviewsList() {
            if(this.myReviews && this.myReviews.length > 0){
                return this.myReviews
            }
            return false
        },
        reviewStars() {
            if(this.myReviewsList){
                let sumStars = 0
                for(let x=0; x < this.myReviewsList.length; x++){
                    sumStars += this.myReviewsList[x].stars
                }
                let avg = (sumStars / this.myReviewsList.length)
                
                let star = {}
                star.full = Math.floor(avg)
                star.half = avg % 1 == 0 ? 0 : 1 
                star.empty = 5 - (star.full + star.half)
                star.rating = Number((avg).toFixed(1))
                return star
            }
            return false
        },
        reviewsCount() {
            if(this.myReviewsList){
                if(this.myReviewsList.length > 0){
                    return this.myReviewsList.length
                }
                return false
            }
            return false
        },
        trueReviewee() {
            // ensures the review recipent is the intended user
            if(this.lookupUser && this.reviewTrans && this.reviewTrans !== null) {
                if(this.reviewTrans.buyerId == this.lookupUser._id){
                    return true
                }
            }
            return false
        },
        referrerCheckFxn() { // REMOVE AFTER REFER N EARN
            if(this.user && this.user.roles){
                let userRoles = this.user.roles
                let portalRoles = [process.env.VUE_APP_SRP_ROLE, process.env.VUE_APP_RFR_ROLE]
                // js some() fxn returns true if some of the el in arry one exists in array two
                let rolesCheck = userRoles.some((val) => portalRoles.indexOf(val) !== -1);  
                if(rolesCheck !== false){
                    return false
                }
            }
            return true
        }
    },
    components: {
        appUserItem: UserItem,
        appAccount: Account,
        appProfileHolder: ProfileHolder,
        appValidateEmail: ValidateEmail,
        appGhostMode: GhostMode
    },
    watch: {
        $route() {
            this.updatePage(this.$route.params.handle)
        }
    },
    created() {
        // check to see if a user is requested via user handle
        if(this.$route.params.handle){
            this.updatePage(this.$route.params.handle)
        }
        if(!this.sellings && this.authenticated){
            this.itemsIamSelling().then(() => {}).catch((e) => {})
        }
        eventBus.$on('hideGhostMode', (value) => {
            this.showNote = value;
            this.showVerifyEmail = value;
            this.showJoinMarketer = value;
        })
        this.$emit('update:layout', LayoutUser);
        this.footerFixed(false)
    }
}
</script>